<template>
  <div id="page">
    <div class="sidebar" :class="isOpened ? 'open' : ''">
      <div class="header">
        <!-- <i class="icofont-navigation-menu" id="btn" @click="toggleSidebar()" /> -->
        <img src="@/assets/images/logo-mini.png" alt="" />
        <i
          class="icon-btn"
          @click="toggleSidebar()"
          :class="isOpened ? 'icofont-circled-left' : 'icofont-circled-right'"
        ></i>
        <div class="logo_name">eSUS Feedback</div>
      </div>
      <div class="sidebar-menu">
        <div id="my-scroll">
          <ul class="nav-list" style="overflow: visible">
            <span>
              <li>
                <router-link to="/">
                  <i class="icofont-home" />
                  <span class="links_name">Início</span>
                </router-link>
                <span class="tooltip"> Início </span>
              </li>
              <li>
                <router-link to="/nosso-dia-a-dia">
                  <i class="icofont-book" />
                  <span class="links_name">Nosso dia a dia</span>
                </router-link>
                <span class="tooltip"> Nosso dia a dia </span>
              </li>
              <li>
                <router-link to="/uso-cientifico">
                  <i class="icofont-book" />
                  <span class="links_name">Uso científico</span>
                </router-link>
                <span class="tooltip"> Uso científico </span>
              </li>
              <!--
              <li>
                <router-link to="/recursos">
                  <i class="icofont-star" />
                  <span class="links_name">RECURSOS</span>
                </router-link>
                <span class="tooltip">
                  RECURSOS
                </span>
              </li>
              -->
              <li>
                <a href="#" @click.prevent.stop="openModalContact()">
                  <i class="icofont-phone" />
                  <span class="links_name">Contato</span>
                </a>
                <span class="tooltip"> Contato </span>
              </li>
              <li>
                <router-link to="/avaliacoes">
                  <i class="icofont-comment" />
                  <span class="links_name">Avaliações</span>
                </router-link>
                <span class="tooltip"> Avaliações </span>
              </li>
              <li>
                <a href="https://politica.esusfeedback.com.br/" target="_blank">
                  <i class="icofont-law-document"></i>
                  <span class="links_name">Política de privacidade</span>
                </a>
                <span class="tooltip"> Política de privacidade </span>
              </li>
              <li>
                <router-link to="/termos-de-uso">
                  <i class="icofont-law-document"></i>
                  <span class="links_name">Termos de uso</span>
                </router-link>
                <span class="tooltip"> Termos de uso </span>
              </li>
              <li>
                <a href="/login" target="_blank">
                  <i class="icofont-user-alt-7"></i>
                  <span class="links_name">Acesso Restrito</span>
                </a>
                <span class="tooltip"> Acesso Restrito </span>
              </li>
              <li>
                <router-link to="/demonstracao">
                  <i class="icofont-user-alt-7"></i>
                  <span class="links_name">Demonstração</span>
                </router-link>
                <span class="tooltip"> Demonstração </span>
              </li>
              <li>
                <a href="/documentacao" target="_blank">
                  <i class="icofont-file-document"></i>
                  <span class="links_name">Documentação</span>
                </a>
              </li>
              <li class="dropdown">
                <a
                  href="#"
                  v-on:click.prevent.stop="openDropdown('myDropdown2')"
                >
                  <i class="icofont-money"></i>
                  <span class="links_name">
                    Cofinan. federal
                    <i class="icofont-caret-down"></i>
                  </span>
                </a>
                <ul
                  id="myDropdown2"
                  class="dropdown-content show-dropdown my-dropdown-2-content"
                >
                  <li>
                    <router-link to="/cofinanciamento/mapa-ied"
                      >Mapa IED</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/cofinanciamento/mapa-ubs" target="_blank"
                      >Mapa UBS</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/cofinanciamento/simulacao"
                      >Simulação</router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="dropdown show-dropdown">
                <a
                  href="#"
                  v-on:click.prevent.stop="openDropdown('myDropdown')"
                >
                  <img src="@/assets/images/logopb.png" alt="" />
                  <span class="links_name">
                    <s>Previne Brasil</s>
                    <i class="icofont-caret-down"></i>
                  </span>
                </a>
                <!-- <span class="tooltip">
                  Previne Brasil
                </span> -->
                <ul id="myDropdown" class="dropdown-content">
                  <li>
                    <router-link to="/previne-brasil/lista"
                      >Ranking geral</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/previne-brasil/estados"
                      >Ranking estados</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/previne-brasil/regional"
                      >Ranking regional</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/previne-brasil/municipios-na-meta"
                      >% Municípios na meta</router-link
                    >
                  </li>
                  <li>
                    <hr />
                  </li>
                  <li>
                    <router-link to="/previne-brasil/mapa-desempenho"
                      >Mapa Desempenho</router-link
                    >
                  </li>
                </ul>
              </li>
              <!--
                <li>
                <a href="/orcamento" target="_blank">
                  <i class="icofont-tasks-alt"></i>
                  <span class="links_name">Orçamento</span>
                </a>
                <span class="tooltip">
                  Orçamento
                </span>
              </li>
              <li>
                <a href="/relatorio" target="_blank">
                  <i class="icofont-tasks-alt"></i>
                  <span class="links_name">Relatório</span>
                </a>
                <span class="tooltip">
                  Relatório
                </span>
              </li> -->
            </span>
          </ul>
        </div>
      </div>
    </div>
    <div class="content" :class="isOpened ? 'content-open' : ''">
      <router-view @closeMenu="closeMenu"></router-view>
    </div>
    <div id="myModal" class="modal-contact modal" v-if="active">
      <div class="modal-content">
        <span class="close" @click="active = false">&times;</span>
        <h3><i class="icofont-ui-contact-list"></i> Contatos</h3>
        <p>
          Seleciona o seu estado e sua cidade para obter os dados de contato.
        </p>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group input-group">
              <vue-select
                :options="estados"
                label="uf"
                placeholder="ESTADO"
                @input="onChangeEstados"
                class="vue-select-estado"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group input-group">
              <vue-select
                :options="cidades"
                label="no_municipio"
                placeholder="CIDADE"
                @input="onChangeCidades"
                class="vue-select-cidade"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <div class="col-12">
            <div class="contatos">
              <ul v-if="contato.cpf != null">
                <li><i class="icofont-envelope"></i> {{ contato.email }}</li>
                <li>
                  <i class="icofont-phone"></i> {{ contato.contato1 | phone }}
                </li>
                <li>
                  <i class="icofont-phone"></i> {{ contato.contato2 | phone }}
                </li>
              </ul>
              <ul v-else>
                <li><i class="icofont-envelope"></i> contato@biatic.com.br</li>
                <li><i class="icofont-phone"></i> (83) 99841-4823</li>
                <li><i class="icofont-phone"></i> (83) 98206-1060</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'Index',
  components: {
    'vue-select': VueSelect,
  },
  filters: {
    phone: function (value) {
      return value
        .replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    },
  },
  beforeMount() {
    if (window.innerWidth < 1023) {
      this.isOpened = false
    } else {
      this.isOpened = true
    }
  },
  data() {
    return {
      isOpened: true,
      active: false,
      estados: [
        { uf: 'AC' },
        { uf: 'AL' },
        { uf: 'AP' },
        { uf: 'AM' },
        { uf: 'BA' },
        { uf: 'CE' },
        { uf: 'DF' },
        { uf: 'ES' },
        { uf: 'GO' },
        { uf: 'MA' },
        { uf: 'MT' },
        { uf: 'MS' },
        { uf: 'MG' },
        { uf: 'PA' },
        { uf: 'PB' },
        { uf: 'PR' },
        { uf: 'PE' },
        { uf: 'PI' },
        { uf: 'RJ' },
        { uf: 'RN' },
        { uf: 'RS' },
        { uf: 'RO' },
        { uf: 'RR' },
        { uf: 'SC' },
        { uf: 'SP' },
        { uf: 'SR' },
        { uf: 'TO' },
      ],
      estado: '',
      cidade: '',
      cidades: [],
      contato: {
        email: '',
        contato1: '',
        contato2: '',
        cpf: '',
      },
    }
  },
  methods: {
    closeMenu() {
      this.isOpened = false
    },
    toggleSidebar() {
      this.isOpened = !this.isOpened
    },

    scrollElement(id) {
      let route = this.$router.history.current.path
      if (
        route == '/termos-de-uso' ||
        route == '/criar-conta' ||
        route == '/recuperar-senha'
      ) {
        this.$router.push('/' + id)
      } else {
        let tag = document.getElementById(id)
        window.scroll({
          behavior: 'smooth',
          left: 0,
          top: tag.offsetTop - 180,
        })
      }
    },
    buscarCidades(estado) {
      this.$apiPublic
        .get('/cidades-por-uf/' + estado)
        .then((response) => {
          this.cidades = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeEstados(event) {
      let estado = event.uf
      this.$apiPublic
        .get('/cidades-por-uf/' + estado)
        .then((response) => {
          this.cidades = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeCidades(event) {
      this.cidade = event.co_ibge
      this.$apiPublic
        .get('/contatos/' + this.cidade)
        .then((response) => {
          this.contato.email = response.data[0].email_contato
          this.contato.contato1 = response.data[0].celular_contato1
          this.contato.contato2 = response.data[0].celular_contato2
          this.contato.cpf = response.data[0].cpf_contato
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    openDropdown(id) {
      document.getElementById(id).classList.toggle('show-dropdown')
    },

    openModalContact() {
      this.active = true
      console.log('modal contact')
      this.isOpened = false
    },
  },
}
</script>

<style>
#page {
  background-color: #f4f6fd;
}

.sidebar {
  position: relative;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  min-height: min-content;
  /* overflow-y: auto; */
  width: 65px;
  background: #fff;
  /* padding: 6px 14px 0 14px; */
  z-index: 99;
  transition: all 0.5s ease;
  /* box-shadow: 0px 0px 35px 0px hsla(215, 9%, 64%, 0.15); */
  box-shadow: 0 0 21px 0 rgb(89 102 122 / 10%);
}
.sidebar.open {
  width: 240px;
}
.sidebar .header {
  height: 60px;
  display: inline-flex;
  align-items: center;
  margin: 6px 9px 0px;
  position: relative;
}
.sidebar .header .logo {
  opacity: 0;
  transition: all 0.5s ease;
}
.sidebar .header img {
  width: 30px;
  margin: 0 10px;
}
.sidebar .header .logo_name {
  color: #000;
  font-size: 20px;
  font-weight: 600;
  opacity: 0;
  transition: all 0.5s ease;
}
.sidebar .header .icon-btn {
  position: absolute;
  right: -34px;
  cursor: pointer;
  z-index: 999;
}
.sidebar.open .header .logo,
.sidebar.open .header .logo_name {
  opacity: 1;
}
.sidebar .header #btn {
  font-size: 22px;
  transition: all 0.4s ease;
  font-size: 23px;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
}
.sidebar i {
  color: #0d98bb;
  height: 60px;
  min-width: 50px;
  font-size: 28px;
  text-align: center;
  line-height: 60px;
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  max-height: calc(100% - 0px);
  overflow: auto;
}

.sidebar .nav-list {
  margin-top: 20px;
  /* margin-bottom: 60px; */
  /* height: 100%; */
  /* min-height: min-content; */
}
.sidebar li {
  position: relative;
  list-style: none;
}
.sidebar li:hover {
  box-shadow: 3px 0 0 0 #0d98bb inset;
  background-color: rgba(242, 242, 242, 0.5);
}
.sidebar li .tooltip {
  position: absolute;
  top: -20px;
  left: calc(100% + 15px);
  z-index: 3;
  background: #0d98bb;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  opacity: 0;
  white-space: nowrap;
  pointer-events: none;
  transition: 0s;
  color: #fff;
}
.sidebar li:hover .tooltip {
  opacity: 1;
  pointer-events: auto;
  transition: all 0.4s ease;
  top: 50%;
  transform: translateY(-50%);
}

.sidebar.open li:hover .tooltip {
  opacity: 0;
}

.sidebar li a {
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  align-items: center;
  text-decoration: none;
  transition: all 0.4s ease;
  margin: 0 8px;
}

.sidebar li a .links_name {
  color: #000;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: 0.4s;
}
.sidebar.open li a .links_name {
  opacity: 1;
  pointer-events: auto;
}
.sidebar li a:hover .links_name,
.sidebar li a:hover i {
  transition: all 0.5s ease;
}
.sidebar li i {
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  border-radius: 12px;
}
.my-scroll-active {
  overflow-y: auto;
}

.sidebar.open #my-scroll {
  height: calc(100% - 0px);
}

@media (min-width: 768px) and (max-width: 1280px) {
  .sidebar.open #my-scroll {
    overflow-y: scroll;
    overflow-x: clip;
  }
}

.sidebar #my-scroll {
  overflow-y: auto;
  overflow-x: clip;
  height: calc(100% - 0px);
}

.sidebar li:hover {
  box-shadow: 3px 0 0 0 #0d98bb inset;
  background-color: #f2f2f2 !important;
}

.sidebar li:hover {
  box-shadow: 3px 0 0 0 #0d98bb inset;
  background-color: #f2f2f2 !important;
}

.dropdown-content li a {
  /* color: #2196f3 !important; */
  color: #0d98bb !important;
  font-weight: bold !important;
}
@media (max-width: 420px) {
  .sidebar li .tooltip {
    display: none;
  }
}

.sidebar.open .show-dropdown {
  display: block !important;
}

.dropdown-content {
  display: none;
  background-color: #f2f2f2;
  padding: 10px 27px;
  overflow-y: scroll;
  height: 230px;
}

.dropdown-submenu {
  padding: 10px 15px;
}

.dropdown-content li a {
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  align-items: center;
  text-decoration: none;
  transition: all 0.4s ease;
  margin: 0 8px;
  font-size: 14px;
  color: #000;
}

.dropdown-submenu li:hover {
  box-shadow: none;
}

.dropdown img {
  width: 25px;
  margin: 0 15px 0 10px;
}

.sidebar:not(.open) .dropdown:hover .dropdown-content {
  display: block;
  position: absolute;
  top: 0;
  left: 100%;
  width: 220px;
  z-index: 9;
}

.dropdown-content::-webkit-scrollbar {
  width: 5px;
}
.dropdown-content::-webkit-scrollbar-track {
  background-color: #f4f4f4;
}

.dropdown-content::-webkit-scrollbar-thumb {
  background-color: #ccc;
}
/* .dropdown-content::-webkit-scrollbar-thumb:hover {
  background: #0d98bb;
} */

.sidebar .footer {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar .footer .social-media-item {
  width: 100%;
}

.sidebar .footer .social-media-item a {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #000;
}

.sidebar .footer .social-media-item a i {
  height: 50px;
  line-height: 50px;
  font-size: 25px;
}

.sidebar .footer .social-media-item.instagram a i {
  color: #523fcf;
}

.sidebar .footer .social-media-item.youtube a i {
  color: red;
}

.sidebar .footer .social-media-item a h5 {
  font-size: 14px;
}

.sidebar:not(.open) .footer {
  flex-direction: column;
  gap: 0;
}

.sidebar:not(.open) .footer .social-media-item:hover {
  box-shadow: 3px 0 0 0 #0d98bb inset;
  background-color: rgba(242, 242, 242, 0.5);
}

.sidebar:not(.open) .footer .social-media-item a i {
  font-size: 18px;
}

.sidebar:not(.open) .footer .social-media-item a h5 {
  display: none;
}

.content.content-open {
  padding-left: 270px !important;
  transition: all 0.5s ease;
}

.content:not(.content-open) {
  transition: all 0.5s ease;
  padding-left: 100px !important;
}

.content .content-main {
  padding: 20px 30px 20px 20px;
}

.modal-contact {
  z-index: 999 !important;
}

.modal-contact .modal-content .vue-select-estado,
.modal-contact .modal-content .vue-select-cidade {
  width: 100%;
}

@media screen and (max-width: 656px) {
  #page {
    overflow-y: hidden;
  }
  .content:not(.content-open) {
    transition: all 0.5s ease;
    padding-left: 60px !important;
  }
  .content .content-main {
    padding: 20px 15px 20px 25px;
  }
  .content.content-open {
    /*  padding-left: 270px !important; */
    padding-left: unset !important;
  }
  .dropdown-content {
    height: 250px;
  }
}
@media screen and (min-width: 657px) and (max-width: 807px) {
  .content:not(.content-open) {
    transition: all 0.5s ease;
    padding-left: 100px !important;
  }
  .dropdown-content {
    height: 250px;
  }
}
@media screen and (min-width: 808px) and (max-width: 1023px) {
  .content:not(.content-open) {
    transition: all 0.5s ease;
    padding-left: 100px !important;
  }
  .dropdown-content {
    height: 250px;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1265px) {
  .dropdown-content {
    height: 200px;
  }
}

@media screen and (min-width: 1265px) and (max-width: 1600px) {
  .dropdown-content {
    height: 110px;
  }
}

#myModal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
#myModal .modal-content {
  background-color: #fefefe;
  margin: 5% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 53%; /* Could be more or less, depending on screen size */
}

#myModal .modal-content h3 {
  text-align: center;
}

/* The Close Button */
#myModal .close {
  color: #aaa;
  float: right;
  font-size: 45px;
  font-weight: bold;
  text-align: right;
}

#myModal .close:hover,
#myModal .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

#myModal .modal-content-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

#myModal .modal-content-btn .btn3d {
  transition: all 0.08s linear;
  position: relative;
  outline: medium none;
  -moz-outline-style: none;
  border: 0px;
  margin: 15px;
  width: 210px;
}

#myModal .modal-content-btn .btn3d:focus {
  outline: medium none;
  -moz-outline-style: none;
}

#myModal .btn-android {
  box-shadow: 0 0 0 1px #5cb85c inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #4cae4c, 0 8px 0 1px rgba(0, 0, 0, 0.4),
    0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #5cb85c;
  color: #fff;
}

#myModal .btn-apple {
  box-shadow: 0 0 0 1px #fff inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #ccc, 0 8px 0 1px rgba(0, 0, 0, 0.4),
    0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #ccc;
}

#myModal .btn-indicador {
  width: 300px !important;
  box-shadow: 0 0 0 1px #4aa5bc inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #4aa5bc, 0 8px 0 1px rgba(0, 0, 0, 0.4),
    0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #4aa5bc;
  color: #fff;
}

#myModal a .button-live {
  margin: 15px auto;
  width: 250px;
  padding: 15px;
  border-radius: 32px;
  display: block;
  background-color: #0fafd7;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  border: none;
}

/*
    ##Device = Tablets, Ipads (portrait)
    ##Screen = B/w 768px to 1024px
    */

@media (min-width: 768px) and (max-width: 1024px) {
  #myModal .modal-content-btn {
    flex-direction: column;
  }

  #myModal .modal-content-btn .btn3d.btn-android {
    margin-bottom: 0;
  }
}
/*
    ##Device = Most of the Smartphones Mobiles (Portrait)
    ##Screen = B/w 320px to 479px
    */

@media (min-width: 320px) and (max-width: 480px) {
  #myModal .modal-content {
    margin: 15% auto; /* 15% from the top and centered */
    padding: 20px;
    width: 80%; /* Could be more or less, depending on screen size */
  }

  #myModal .modal-content-btn {
    flex-direction: column;
  }

  #myModal .modal-content-btn .btn3d {
    margin: 10px;
    width: 270px !important;
  }

  #myModal .btn-indicador {
    font-size: 17px;
    margin-top: 0;
  }
}
.my-dropdown-2-content {
  height: unset;
  overflow: hidden;
}
</style>
